import {Component, Input} from '@angular/core';
import {NavBaseComponent} from '../nav-base/nav-base.component';
import {TranslateService} from '../../shared/translate.service';

@Component({
  selector: 'app-nav-block',
  templateUrl: './nav-block.component.html',
  styleUrls: ['../nav-base/nav-base.component.scss', './nav-block.component.scss']
})
export class NavBlockComponent extends NavBaseComponent {

  @Input() searchMode = false;

  showMenu = false;

  showAccount = false;

  showSearch = false;

  constructor(public translateService: TranslateService){
    super()
  }

  toggleMenu() {
    this.showMenu = !this.showMenu;
    this.showAccount = false;
    this.showSearch = false;
  }

  toggleAccount() {
    this.showAccount = !this.showAccount;
    this.showMenu = false;
    this.showSearch = false;
  }

  toggleSearch() {
    this.showSearch = !this.showSearch;
    this.showAccount = false;
    this.showMenu = false;
  }
}
